import { StyleSheet } from 'react-native';
import { spacing } from '../../shared/theme/spacing'
import { typography } from '../../shared/theme/typography';
import { ticketColors } from '../../shared/theme/ticketColors'
import { ticketSurfaces } from '../../shared/ticket/ticketSurfaces.styles';

export const saleDetailStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: ticketColors.bg,
  },
  contentWrap: {
    flex: 1,
    minHeight: 0,
  },
  contentWrapWorkspace: {
    width: '100%',
    alignSelf: 'stretch',
    backgroundColor: ticketColors.bg,
  },
  scroll: {
    flex: 1,
  },
  scrollContent: {
    padding: spacing.lg,
    paddingBottom: spacing.xxl,
    gap: spacing.sm,
  },
  scrollContentWorkspace: {
    paddingHorizontal: spacing.md,
    paddingTop: spacing.md,
    maxWidth: '100%',
  },
  scrollContentWithFooter: {
    paddingBottom: spacing.xxl + 88,
  },
  caption: {
    ...typography.caption,
    color: ticketColors.ink2,
    flexShrink: 1,
  },
  fieldRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: spacing.md,
    width: '100%',
  },
  fieldLabel: {
    ...typography.body,
    color: ticketColors.ink2,
    flexShrink: 0,
    maxWidth: '42%',
    paddingTop: 1,
  },
  fieldValue: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '600',
    flex: 1,
    minWidth: 0,
    flexShrink: 1,
    textAlign: 'right',
  },
  fieldsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.sm,
  },
  fieldRowInGrid: {
    flexBasis: '47%',
    minWidth: 200,
    flexGrow: 1,
  },
  saleDetailSummaryBlock: {
    gap: spacing.sm,
    paddingBottom: spacing.sm,
  },
  saleDetailHero: {
    ...ticketSurfaces.paperSheet,
    padding: spacing.md,
    gap: spacing.sm,
    width: '100%',
  },
  saleDetailHeroTop: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: spacing.sm,
    width: '100%',
  },
  saleDetailHeroAmount: {
    ...typography.titleXL,
    color: ticketColors.ink,
    fontWeight: '900',
    letterSpacing: -0.5,
  },
  saleDetailHeroMeta: {
    ...typography.caption,
    color: ticketColors.ink3,
    flexShrink: 1,
    lineHeight: 18,
  },
  saleDetailTotalsRow: {
    marginTop: spacing.xs,
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: spacing.xs,
  },
  saleDetailTotalsLabel: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '600',
  },
  saleDetailDiscountBadge: {
    borderRadius: 999,
    borderWidth: 1,
    borderColor: 'rgba(74, 222, 128, 0.45)',
    backgroundColor: 'rgba(74, 222, 128, 0.12)',
    paddingHorizontal: spacing.sm,
    paddingVertical: 4,
  },
  saleDetailDiscountBadgeText: {
    ...typography.caption,
    color: 'rgba(134, 239, 172, 0.95)',
    fontWeight: '700',
  },
  saleDetailChipRow: {
    marginTop: 2,
  },
  saleDetailKpiGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.sm,
    width: '100%',
  },
  saleDetailKpiCell: {
    ...ticketSurfaces.paperSheet,
    flexGrow: 1,
    flexBasis: '30%',
    minWidth: 120,
    borderRadius: 14,
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.sm,
    gap: 2,
  },
  saleDetailKpiLabel: {
    ...typography.caption,
    color: ticketColors.ink3,
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: 0.35,
    fontSize: 10,
  },
  saleDetailKpiValue: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '700',
    flexShrink: 1,
  },
  saleDetailKpiCellEmphasis: {
    justifyContent: 'space-between',
    minHeight: 64,
  },
  saleDetailKpiCellSuccess: {
    borderColor: 'rgba(74, 222, 128, 0.45)',
    backgroundColor: 'rgba(74, 222, 128, 0.08)',
  },
  saleDetailKpiCellWarning: {
    borderColor: 'rgba(251, 191, 36, 0.45)',
    backgroundColor: 'rgba(251, 191, 36, 0.08)',
  },
  saleDetailKpiCellDanger: {
    borderColor: 'rgba(248, 113, 113, 0.45)',
    backgroundColor: 'rgba(248, 113, 113, 0.08)',
  },
  saleDetailKpiCellService: {
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.paper,
  },
  saleDetailContextLine: {
    ...typography.caption,
    color: ticketColors.ink2,
    lineHeight: 18,
    flexShrink: 1,
  },
  saleDetailContextGrid: {
    gap: spacing.xs,
    width: '100%',
  },
  saleDetailContextRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: spacing.sm,
    width: '100%',
  },
  saleDetailContextLabel: {
    ...typography.caption,
    color: ticketColors.ink3,
    fontWeight: '600',
    width: 88,
    flexShrink: 0,
  },
  saleDetailContextValue: {
    ...typography.caption,
    color: ticketColors.ink2,
    flex: 1,
    minWidth: 0,
    flexShrink: 1,
  },
  sectionTitle: {
    ...typography.body,
    fontWeight: '700',
    color: ticketColors.ink,
    marginTop: spacing.md,
  },
  sectionTitleInCard: {
    marginTop: 0,
    marginBottom: spacing.xs,
  },
  summaryHeaderRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
    width: '100%',
  },
  summaryHeaderCaption: {
    ...typography.caption,
    color: ticketColors.ink2,
    flex: 1,
    minWidth: 0,
    flexShrink: 1,
  },
  voidedBanner: {
    padding: spacing.md,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: ticketColors.bad,
    backgroundColor: 'rgba(248, 113, 113, 0.12)',
    width: '100%',
    gap: spacing.xs,
  },
  voidedBannerTitle: {
    ...typography.body,
    color: ticketColors.bad,
    fontWeight: '800',
    flexShrink: 1,
  },
  voidedBannerText: {
    ...typography.caption,
    color: ticketColors.ink,
    flexShrink: 1,
    lineHeight: 20,
  },
  voidedFieldValue: {
    textDecorationLine: 'line-through',
    color: ticketColors.ink2,
  },
  voidReasonBlock: {
    marginTop: spacing.xs,
    gap: spacing.xs,
    width: '100%',
    padding: spacing.md,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: 'rgba(248, 113, 113, 0.35)',
    backgroundColor: 'rgba(248, 113, 113, 0.06)',
  },
  voidReasonText: {
    ...typography.body,
    color: ticketColors.ink,
    flexShrink: 1,
  },
  customerBanner: {
    marginTop: spacing.xs,
    padding: spacing.md,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: ticketColors.gold,
    backgroundColor: 'rgba(251, 191, 36, 0.12)',
    width: '100%',
  },
  customerBannerText: {
    ...typography.caption,
    color: ticketColors.ink,
    flexShrink: 1,
  },
  saleDetailSection: {
    gap: spacing.sm,
    marginTop: spacing.xs,
  },
  saleDetailItemRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: spacing.md,
    paddingVertical: spacing.sm,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.rule,
    width: '100%',
  },
  saleDetailItemRowLast: {
    borderBottomWidth: 0,
    paddingBottom: 0,
  },
  saleDetailItemMain: {
    flex: 1,
    minWidth: 0,
    gap: 4,
  },
  saleDetailItemName: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '600',
    flexShrink: 1,
  },
  saleDetailItemAmount: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '700',
    flexShrink: 0,
    maxWidth: '38%',
    textAlign: 'right',
    paddingTop: 1,
  },
  saleDetailItemAmountCol: {
    alignItems: 'flex-end',
    gap: 2,
    flexShrink: 0,
  },
  saleDetailItemAmountList: {
    ...typography.caption,
    color: ticketColors.ink2,
    textDecorationLine: 'line-through',
  },
  saleDetailItemAmountNet: {
    color: ticketColors.ink,
  },
  saleDetailItemCode: {
    ...typography.caption,
    color: ticketColors.ink3,
    flexShrink: 1,
  },
  saleDetailLinePromoHint: {
    ...typography.caption,
    color: 'rgba(134, 239, 172, 0.95)',
    fontWeight: '700',
  },
  saleDetailItemsMobileWrap: {
    gap: spacing.sm,
    width: '100%',
  },
  checkoutDetailTableWrap: {
    ...ticketSurfaces.paperSheet,
    borderRadius: 14,
    width: '100%',
  },
  checkoutDetailTableHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.sm,
    backgroundColor: ticketColors.paper2,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.ruleSoft,
    gap: spacing.xs,
  },
  checkoutDetailTableRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.sm,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.rule,
    gap: spacing.xs,
    backgroundColor: ticketColors.paper,
  },
  checkoutDetailTableRowLast: {
    borderBottomWidth: 0,
  },
  checkoutDetailCell: {
    ...typography.caption,
    color: ticketColors.ink,
  },
  checkoutDetailCellProduct: {
    flex: 1.6,
    minWidth: 140,
  },
  checkoutDetailCellQty: {
    flex: 0.7,
    minWidth: 72,
    textAlign: 'center',
  },
  checkoutDetailCellMoney: {
    flex: 0.9,
    minWidth: 92,
    textAlign: 'right',
    fontVariant: ['tabular-nums'],
  },
  checkoutDetailDiscount: {
    color: ticketColors.ok,
    fontWeight: '700',
  },
  checkoutDetailNet: {
    fontWeight: '700',
  },
  checkoutPromoSummaryBlock: {
    marginTop: spacing.sm,
    gap: spacing.sm,
    paddingTop: spacing.sm,
    paddingHorizontal: spacing.sm,
    paddingBottom: spacing.sm,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.ruleSoft,
    borderRadius: 10,
    backgroundColor: ticketColors.tile,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
  },
  checkoutPromoSummaryTitle: {
    ...typography.caption,
    color: ticketColors.ink3,
    fontWeight: '800',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  checkoutPromoSummaryRow: {
    gap: 2,
    paddingVertical: 2,
  },
  checkoutPromoSummaryName: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '800',
  },
  checkoutPromoSummaryMeta: {
    ...typography.caption,
    color: ticketColors.ok,
    fontWeight: '700',
  },
  saleDetailPaymentBlock: {
    gap: spacing.sm,
    width: '100%',
  },
  saleDetailPaymentHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
    width: '100%',
  },
  saleDetailPaymentBlockLast: {
    borderBottomWidth: 0,
  },
  saleDetailPaymentBlockDivider: {
    marginTop: spacing.sm,
    paddingTop: spacing.sm,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.rule,
  },
  saleDetailPaymentAmountHero: {
    ...typography.title3,
    color: ticketColors.ink,
    fontWeight: '800',
    fontVariant: ['tabular-nums'],
  },
  saleDetailPaymentStatusCell: {
    flex: 1,
    minWidth: 0,
    alignItems: 'flex-start',
  },
  saleDetailOperationValue: {
    fontWeight: '700',
    fontVariant: ['tabular-nums'],
    color: ticketColors.ink,
  },
  voidSaleButton: {
    marginTop: spacing.sm,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: ticketColors.bad,
    backgroundColor: 'rgba(248, 113, 113, 0.12)',
    paddingVertical: spacing.md,
    paddingHorizontal: spacing.md,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 48,
    width: '100%',
  },
  voidSaleButtonText: {
    ...typography.body,
    color: ticketColors.bad,
    fontWeight: '700',
    textAlign: 'center',
  },
  saleDetailActions: {
    marginTop: spacing.lg,
    gap: spacing.sm,
    width: '100%',
  },
  collectCustomerButton: {
    borderRadius: 16,
    borderWidth: 1,
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.gold,
    paddingVertical: spacing.md,
    paddingHorizontal: spacing.md,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 48,
    width: '100%',
  },
  collectCustomerButtonText: {
    ...typography.body,
    color: ticketColors.goldInk,
    fontWeight: '700',
    textAlign: 'center',
  },
  footerVoid: {
    paddingHorizontal: spacing.lg,
    paddingTop: spacing.md,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.rule,
    backgroundColor: ticketColors.paper,
  },
  fiscalComprobanteCard: {
    ...ticketSurfaces.paperSheet,
    padding: spacing.md,
    gap: spacing.sm,
  },
  fiscalComprobanteRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
  },
  fiscalComprobanteStatus: {
    ...typography.body,
    fontWeight: '700',
    color: ticketColors.ink,
  },
  fiscalComprobanteCae: {
    ...typography.caption,
    color: ticketColors.ink2,
  },
  fiscalComprobanteActions: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.md,
    marginTop: spacing.xs,
  },
  fiscalActionBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  fiscalActionText: {
    ...typography.caption,
    color: ticketColors.ink,
    fontWeight: '600',
  },
  // ── Mobile clean design ──
  mobileScrollContent: {
    padding: spacing.md,
    paddingBottom: spacing.xxl,
    gap: 20,
  },
  mobileHero: {
    gap: 4,
    paddingVertical: 4,
  },
  mobileHeroKicker: {
    fontSize: 13,
    fontWeight: '600',
    color: ticketColors.ink3,
  },
  mobileHeroTitle: {
    fontSize: 28,
    fontWeight: '800',
    color: ticketColors.ink,
    lineHeight: 32,
    letterSpacing: -0.5,
  },
  mobileHeroTitleVoided: {
    textDecorationLine: 'line-through',
    color: ticketColors.ink2,
  },
  mobileHeroSubtitle: {
    fontSize: 14,
    color: ticketColors.ink2,
    lineHeight: 20,
  },
  mobilePillRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 6,
  },
  mobileMetricCard: {
    ...ticketSurfaces.paperSheet,
    padding: spacing.md,
  },
  mobileMetricRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 10,
  },
  mobileMetricRowDivider: {
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.ruleSoft,
  },
  mobileMetricLabel: {
    fontSize: 15,
    color: ticketColors.ink2,
    fontWeight: '500',
  },
  mobileMetricValue: {
    fontSize: 18,
    fontWeight: '800',
    color: ticketColors.ink,
    fontVariant: ['tabular-nums'],
    letterSpacing: -0.3,
  },
  mobileMetricValueDanger: {
    color: ticketColors.bad,
  },
  mobileMetricValueSuccess: {
    color: ticketColors.ok,
  },
  mobileMetricValueWarning: {
    color: ticketColors.gold,
  },
  mobileContextGrid: {
    gap: 8,
  },
  mobileContextRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
  },
  mobileContextLabel: {
    fontSize: 14,
    color: ticketColors.ink3,
    fontWeight: '500',
  },
  mobileContextValue: {
    fontSize: 14,
    color: ticketColors.ink,
    fontWeight: '600',
    textAlign: 'right',
  },
  mobileDivider: {
    height: StyleSheet.hairlineWidth,
    backgroundColor: ticketColors.ruleSoft,
  },
  mobileSectionTitle: {
    fontSize: 13,
    fontWeight: '700',
    color: ticketColors.ink3,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
    paddingBottom: 6,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.ruleSoft,
  },
  mobileSection: {
    gap: 14,
  },
  mobileItemCard: {
    ...ticketSurfaces.paperSheet,
    padding: 14,
    gap: 4,
  },
  mobileItemTop: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 8,
  },
  mobileItemName: {
    fontSize: 15,
    fontWeight: '700',
    color: ticketColors.ink,
    flex: 1,
    minWidth: 0,
  },
  mobileItemQty: {
    fontSize: 13,
    color: ticketColors.ink3,
    fontWeight: '600',
    flexShrink: 0,
  },
  mobileItemPrice: {
    fontSize: 15,
    fontWeight: '800',
    color: ticketColors.ink,
    fontVariant: ['tabular-nums'],
  },
  mobileItemSku: {
    fontSize: 12,
    color: ticketColors.ink3,
  },
  mobileItemPriceList: {
    fontSize: 13,
    color: ticketColors.ink3,
    textDecorationLine: 'line-through',
  },
  mobileItemAttribution: {
    marginTop: 4,
    gap: 2,
  },
  mobileItemAttributionText: {
    fontSize: 11,
    fontWeight: '500',
    color: ticketColors.ink3,
  },
  mobileItemPromoHint: {
    fontSize: 12,
    color: 'rgba(134, 239, 172, 0.95)',
    fontWeight: '700',
  },
  mobileDiscountRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 8,
  },
  mobileDiscountLabel: {
    fontSize: 14,
    color: ticketColors.ok,
    fontWeight: '600',
  },
  mobileDiscountAmount: {
    fontSize: 14,
    color: ticketColors.ok,
    fontWeight: '800',
  },
  mobilePaymentItem: {
    ...ticketSurfaces.paperSheet,
    padding: 14,
    gap: 4,
  },
  mobilePaymentItemVoided: {
    borderLeftWidth: 3,
    borderLeftColor: ticketColors.bad,
    backgroundColor: 'rgba(239, 68, 68, 0.06)',
  },
  mobilePaymentItemPending: {
    borderLeftWidth: 3,
    borderLeftColor: ticketColors.gold,
  },
  mobilePaymentTop: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
  },
  mobilePaymentTitle: {
    fontSize: 15,
    fontWeight: '700',
    color: ticketColors.ink,
  },
  mobilePaymentTitleVoided: {
    textDecorationLine: 'line-through',
    color: ticketColors.ink2,
  },
  mobilePaymentMeta: {
    fontSize: 13,
    color: ticketColors.ink3,
  },
  mobileEmptyState: {
    alignItems: 'center',
    gap: 8,
    paddingVertical: 24,
    paddingHorizontal: spacing.md,
  },
  mobileEmptyStateText: {
    fontSize: 14,
    color: ticketColors.ink3,
  },
  mobileVoidedBanner: {
    backgroundColor: 'rgba(239, 68, 68, 0.08)',
    borderWidth: 1,
    borderColor: 'rgba(239, 68, 68, 0.2)',
    borderRadius: 14,
    padding: 14,
    gap: 6,
  },
  mobileVoidedBannerTitle: {
    fontSize: 15,
    fontWeight: '700',
    color: ticketColors.bad,
  },
  mobileVoidedBannerText: {
    fontSize: 13,
    color: ticketColors.ink2,
    lineHeight: 18,
  },
  mobileVoidedMeta: {
    fontSize: 13,
    color: ticketColors.ink3,
    lineHeight: 18,
  },
  mobileFooter: {
    padding: 12,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.ruleSoft,
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
  },
  mobileFooterBtn: {
    flexGrow: 1,
    flexBasis: 140,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    paddingVertical: 14,
    paddingHorizontal: 16,
    borderRadius: 10,
    minHeight: 44,
  },
  mobileFooterBtnPrimary: {
    backgroundColor: ticketColors.gold,
  },
  mobileFooterBtnDanger: {
    backgroundColor: ticketColors.warnBg,
    borderWidth: 1,
    borderColor: ticketColors.warnBorder,
  },
  mobileFooterBtnSecondary: {
    backgroundColor: ticketColors.paper2,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
  },
  mobileFooterBtnText: {
    fontSize: 15,
    fontWeight: '700',
    flexShrink: 1,
    textAlign: 'center',
  },
  mobileFooterBtnTextPrimary: {
    color: ticketColors.goldInk,
  },
  mobileFooterBtnTextDanger: {
    color: ticketColors.bad,
  },
  mobileFooterBtnTextSecondary: {
    color: ticketColors.ink2,
  },
  // ── Fiado warn-box (proto ventas-ux-v1 §2, desk + mobile) ──
  fiadoWarnBox: {
    marginTop: 10,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.warnBorder,
    backgroundColor: ticketColors.warnBg,
    paddingVertical: 10,
    paddingHorizontal: 12,
  },
  fiadoWarnText: {
    fontSize: 12.5,
    fontWeight: '600',
    color: ticketColors.warn,
    lineHeight: 17,
  },
  mobileLoadingWrap: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    paddingVertical: 48,
  },
});
